import APIService from './ApiService';
import ApiStorage from './ApiStorage';

const ApiAppService = APIService;

ApiAppService.setApiStorage(ApiStorage);

export default ApiAppService;
